<h2 class="sr-only">{{ "personstamm.tab.ZPVSuche" | translate }}</h2>

<form (ngSubmit)="onSubmit()" [meta]="zpvRequest" #form="ngForm" column-classes="col-md-4,col-md-8">
  <div class="row">
    <div class="col-md-6 col-xs-12">
      <cap-form-control labelKey="Name">
        <input
          (ngModelChange)="zpvRequest && (zpvRequest.name = $event)"
          [ngModel]="zpvRequest && zpvRequest.name"
          #name
          id="name"
          name="name"
          type="text" />
      </cap-form-control>
      <cap-form-control labelKey="Vorname">
        <input
          (ngModelChange)="zpvRequest && (zpvRequest.vorname = $event)"
          [ngModel]="zpvRequest && zpvRequest.vorname"
          id="vorname"
          name="vorname"
          type="text" />
      </cap-form-control>

      <cap-teil-datum
        (ngModelChange)="zpvRequest && (zpvRequest.geburtsdatum = $event)"
        [ngModel]="zpvRequest && zpvRequest.geburtsdatum"
        label="Geburtsdatum"
        name="geburtsdatum"></cap-teil-datum>

      <cap-form-control labelKey="personstamm.ZPVNummer">
        <input
          (ngModelChange)="zpvRequest && (zpvRequest.zpvNummer = $event)"
          [ngModel]="zpvRequest && zpvRequest.zpvNummer"
          id="zpvNummer"
          name="zpvNummer"
          type="text" />
      </cap-form-control>
    </div>

    <div class="col-md-6 col-xs-12">
      <cap-form-control invalidKey="EingabeMussValideUIDSein" labelKey="UID">
        <input
          (ngModelChange)="zpvRequest && (zpvRequest.uid = $event)"
          [ngModel]="zpvRequest && zpvRequest.uid"
          id="uid"
          name="uid"
          type="text" />
      </cap-form-control>
      <cap-form-control invalidKey="EingabeMussValideAHVNummerSein" labelKey="AHVNummer">
        <input
          (ngModelChange)="zpvRequest && (zpvRequest.ahvNummer = $event)"
          [ngModel]="zpvRequest && zpvRequest.ahvNummer"
          id="ahvnummer"
          name="ahvNummer"
          type="text" />
      </cap-form-control>
      <cap-form-control invalidKey="EingabeMussValideAHVNummerSein" labelKey="AHVVersichertennummer">
        <input
          (ngModelChange)="zpvRequest && (zpvRequest.ahvVersichertennummer = $event)"
          [ngModel]="zpvRequest && zpvRequest.ahvVersichertennummer"
          id="ahvVersichertennummer"
          name="ahvVersichertennummer"
          type="text" />
      </cap-form-control>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <h3 class="title-divider mb-2">{{ "Adresse" | translate }}</h3>
      <cap-form-row>
        <cap-form-control column-classes="col-md-4,input-series col col-md-6" labelKey="StrasseOderHausnummer">
          <input
            (ngModelChange)="zpvRequest && zpvRequest.strasseFlurname && (zpvRequest.strasseFlurname.strasseOderFlurname = $event)"
            [ngModel]="zpvRequest && zpvRequest.strasseFlurname && zpvRequest.strasseFlurname.strasseOderFlurname"
            name="strasseOderFlurname"
            size="20"
            type="text" />
        </cap-form-control>
        <cap-form-control column-classes="col-md-4,input-series col col-md-2 col-sm-2">
          <input
            (ngModelChange)="zpvRequest && zpvRequest.strasseFlurname && (zpvRequest.strasseFlurname.nummer = $event)"
            [ngModel]="zpvRequest && zpvRequest.strasseFlurname && zpvRequest.strasseFlurname.nummer"
            name="nummer"
            size="6"
            type="text" />
        </cap-form-control>
      </cap-form-row>

      <cap-form-row>
        <cap-form-control
          column-classes="col-md-4,input-series col col-md-2 col-sm-2"
          invalidKey="EingabeMussValidePLZSein"
          labelKey="PlzOderOrtschaft">
          <input
            (ngModelChange)="zpvRequest && (zpvRequest.plz = $event)"
            [ngModel]="zpvRequest && zpvRequest.plz"
            name="plz"
            size="4"
            type="text" />
        </cap-form-control>
        <cap-form-control column-classes="col-md-6,input-series col col-md-6 col-sm">
          <input
            (ngModelChange)="zpvRequest && (zpvRequest.ort = $event)"
            [ngModel]="zpvRequest && zpvRequest.ort"
            name="ort"
            type="text" />
        </cap-form-control>
      </cap-form-row>
    </div>

    <div class="col-md-6">
      <h3 class="title-divider">{{ "BezugZumGrundbuch" | translate }}</h3>
      <cap-form-control labelKey="MitGrundbuchbezug">
        <input
          (ngModelChange)="zpvRequest && (zpvRequest.sucheMitGrundbuchbezug = $event)"
          [ngModel]="zpvRequest && zpvRequest.sucheMitGrundbuchbezug"
          name="zpvRequest?.sucheMitGrundbuchbezug"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="ohneGrundbuchbezug">
        <input
          (ngModelChange)="zpvRequest && (zpvRequest.sucheOhneGrundbuchbezug = $event)"
          [ngModel]="zpvRequest && zpvRequest.sucheOhneGrundbuchbezug"
          name="zpvRequest?.sucheOhneGrundbuchbezug"
          type="checkbox" />
      </cap-form-control>
    </div>
  </div>

  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid || !zpvRequest?.mZpvNummer" class="btn btn-primary btn-actionpane" type="submit">
        {{ "Suche" | translate }}
      </button>
    </div>
  </div>
</form>
